export default {
  desktop: { zIndex: 3, stickyTop: 90 },
  mobile: { zIndex: 3, stickyTop: 90 },
  // TODO change back
  // desktop: { zIndex: 3, stickyTop: 109 },
  // mobile: { zIndex: 3, stickyTop: 109 },
};
